
const state = {
    segments: [],
    customers: [],
    loading: false
};

export default state;